/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type User_Role_Enum =
  | 'BUYER_DIRECTOR'
  | 'BUYER_FINANCE'
  | 'BUYER_MANAGER'
  | 'BUYER_OWNER'
  | 'COMPANY_ADMIN'
  | 'STAFF_ADMIN'
  | 'SUPPLIER_OWNER'
  | 'SUPPLIER_SALES_ADMIN'
  | 'SUPPLIER_SALES_REP';

export type GetUserRolesByEmailQueryVariables = Exact<{
  email: string;
  companyId: string;
}>;


export type GetUserRolesByEmailQuery = { user: Array<{ id: string, role_assignments: Array<{ role_name: Types.User_Role_Enum | null }> }> };


export const GetUserRolesByEmailDocument = /*#__PURE__*/ gql`
    query GetUserRolesByEmail($email: citext!, $companyId: uuid!) {
  user(where: {email: {_eq: $email}}) {
    id
    role_assignments(where: {companyId: {_eq: $companyId}}) {
      role_name
    }
  }
}
    `;

/**
 * __useGetUserRolesByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserRolesByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetUserRolesByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables> & ({ variables: GetUserRolesByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>(GetUserRolesByEmailDocument, options);
      }
export function useGetUserRolesByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>(GetUserRolesByEmailDocument, options);
        }
// @ts-ignore
export function useGetUserRolesByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>;
export function useGetUserRolesByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserRolesByEmailQuery | undefined, GetUserRolesByEmailQueryVariables>;
export function useGetUserRolesByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>(GetUserRolesByEmailDocument, options);
        }
export type GetUserRolesByEmailQueryHookResult = ReturnType<typeof useGetUserRolesByEmailQuery>;
export type GetUserRolesByEmailLazyQueryHookResult = ReturnType<typeof useGetUserRolesByEmailLazyQuery>;
export type GetUserRolesByEmailSuspenseQueryHookResult = ReturnType<typeof useGetUserRolesByEmailSuspenseQuery>;
export type GetUserRolesByEmailQueryResult = Apollo.QueryResult<GetUserRolesByEmailQuery, GetUserRolesByEmailQueryVariables>;